import { Link } from "react-router-dom"
import AssetPath from "../AssetPath/AssetPath"
import { GoShieldLock } from "react-icons/go"
import { companyName, productName } from "../config"
import "../Screens/Login/login.scss"

const AuthShell = ({
  children,
  title,
  subtitle,
  footer,
  badge,
  wide,
  steps,
  activeStep,
}) => {
  return (
    <section className="auth-shell auth-shell--glass">
      <div className="auth-shell__glow auth-shell__glow--a" aria-hidden />
      <div className="auth-shell__glow auth-shell__glow--b" aria-hidden />
      <div className="auth-shell__mesh" aria-hidden />

      <div className={`auth-card auth-card--glass${wide ? " auth-card--wide" : ""}`}>
        <Link to="/" className="auth-card__brand">
          <img src={AssetPath.brand.appIconCircle} alt="" className="auth-card__brand-mark" />
          <span className="auth-card__brand-name">
            <strong>{productName}</strong>
            <small>{companyName}</small>
          </span>
        </Link>

        <div className="auth-card__badge">
          <GoShieldLock size={14} />
          {badge || "Secure administrator access"}
        </div>

        {Array.isArray(steps) && steps.length ? (
          <ol className="auth-progress" aria-label="Sign-in steps">
            {steps.map((label, index) => {
              const n = index + 1
              const state =
                activeStep === n ? "current" : activeStep > n ? "done" : "upcoming"
              return (
                <li
                  key={label}
                  className={`auth-progress__step auth-progress__step--${state}`}
                >
                  <span className="auth-progress__index">{n}</span>
                  <span className="auth-progress__label">{label}</span>
                </li>
              )
            })}
          </ol>
        ) : null}

        {title ? <h1 className="auth-card__title">{title}</h1> : null}
        {subtitle ? <p className="auth-card__subtitle">{subtitle}</p> : null}
        {children}
        {footer ? <div className="auth-card__footer">{footer}</div> : null}

        <div className="auth-card__legal">
          <span>© {new Date().getFullYear()} {companyName}</span>
          <span className="auth-card__legal-links">
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms</a>
          </span>
        </div>
      </div>
    </section>
  )
}

export default AuthShell
